import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'

import 'bootstrap/dist/css/bootstrap.min.css'

createApp(App).mount('#app')
